import { Button } from '@velocity/ui';
import React from 'react';
import { useSelector } from 'react-redux';
import useDeviceBreakpoint from '../../../hooks/useDeviceBreakpoint';
import useThemeHook from '../../../hooks/useThemeHook';
import Layout from '../../../layout';
import { EDevice } from '../../../redux/sequence/enums';
import { RootState } from '../../../redux/store';
import ArrowList from '../../b2b/components/arrow-list/arrow-list';
import Contact from '../contact/contact';
import StaticFooter from '../footer/footer-static';
import HeaderBar from '../header/header-bar';
import { ReactComponent as GeneralErrorSvg } from '/src/assets/svg/general_error.svg';
import { ReactComponent as GeneralErrorSmallSvg } from '/src/assets/svg/general_error_small.svg';

const GeneralErrorPage: React.FC = () => {
  useDeviceBreakpoint();
  useThemeHook();

  const { device } = useSelector((state: RootState) => state.sequence);

  const headline = (
    <>
      {device === EDevice.MOBILE && (
        <GeneralErrorSmallSvg className='status-svg' />
      )}
      <div>Etwas ist schiefgelaufen</div>
    </>
  );

  const getSubHeading = () => {
    return 'Beim Aufrufen dieser Seite ist ein technischer Fehler aufgetreten. Bitte versuche es erneut.';
  };

  return (
    <>
      <HeaderBar />
      <Layout
        heading={headline}
        subHeading={getSubHeading()}
        hasFullSize={true}
        className='status-overview top-96 grid'
        style={{ gridTemplateRows: '15% 60%' }}
      >
        <div
          className='half-half-columns cancelled top-36'
          style={{ alignItems: 'start' }}
        >
          {(device === EDevice.DESKTOP || device === EDevice.TABLET) && (
            <GeneralErrorSvg className='status-svg' />
          )}
          <div className='flex flex-col gap-4'>
            <div className='content-bold'>Was du jetzt tun kannst</div>

            <ArrowList
              className='dark-grey content-normal'
              list={[
                'Lade die Seite neu.',
                'Sollte der Fehler weiterhin auftreten, hilft dir unser Service-Team gerne weiter.',
              ]}
            />

            <Button
              variant='secondary-filled'
              size='m'
              fullWidth
              margin={{ y: '06' }}
              onClick={() => window.location.reload()}
            >
              Seite neu laden
            </Button>

            <Contact />
          </div>
        </div>
      </Layout>
      <StaticFooter />
    </>
  );
};

export default GeneralErrorPage;
